class WebSocketService {
    constructor(url) {
        this.url = url;
        this.socket = null;
        this.token = null;
        this.onMessageHandler = null;
        this.reconnectInterval = 1000;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.isReconnecting = false;
    }

    setToken(token) {
        this.token = token;
    }

    connect() {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) return;

        if (this.token) {
        // if (token) {
            // this.token = token;
            this.socket = new WebSocket(this.url);

            this.socket.onopen = () => {
                console.log("WebSocket connected");
                this.isReconnecting = false;
                // this.reconnectAttempts = 0;
                this.reconnectInterval = 1000;
                if (this.socket && this.socket.readyState === WebSocket.OPEN) {
                    this.socket.send(JSON.stringify({ type: "authenticate", token: this.token }));
                }
            };

            this.socket.onmessage = async (event) => {
                if (this.onMessageHandler) {
                    await this.onMessageHandler(event);
                }
            };

            this.socket.onerror = (error) => {
                console.error("WebSocket error: ", error);
            };
            this.socket.onclose = () => {
                console.warn("WebSocket disconnected");
                this.socket = null;
                this.reconnect();
            };
        } else {
            console.warn("Could not create WebSocket connection - user is not authenticate");
        }
    }

    setOnMessageHandler(handler) {
        this.onMessageHandler = handler;
    }

    sendMessage(message) {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket.send(JSON.stringify(message));
        } else {
            console.warn("WebSocket not connected, message do not sended");
        }
    }

    disconnect() {
        this.token = null;
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
    }

    async reconnect() {
        if (!this.token) {
            console.warn('Reconnect stopped - no token');
            return;
        }
        if (this.isReconnecting || this.reconnectAttempts >= this.maxReconnectAttempts) {
            console.warn('The maximum number of reconenction attempts has been reached. Stopping...');
            return;
        }
        // this.disconnect();
        this.isReconnecting = true;
        this.reconnectAttempts++;
        console.log(`Attempting to recconect (${this.reconnectAttempts}/${this.maxReconnectAttempts}) via ${this.reconnectInterval / 1000} sec...`);
        setTimeout(() => {
            this.isReconnecting = false;
            this.connect();
            this.reconnectInterval = Math.min(this.reconnectInterval * 2, 5000);
        }, this.reconnectInterval);
    }
}

export default WebSocketService;